const initialCoordinates = (data, chartAccuracy) => {
    const x = [];
    const y = [];

    const firstX = data.x_1;
    const secondX = data.x_2;
    const firstY = data.y_1;
    const secondY = data.y_2;
    const slope = data.slope;

    const stepX = (secondX - firstX) / (chartAccuracy - 1);

    x.unshift(firstX);
    for (let i = 1; i < chartAccuracy - 1; i++) {
        x.push(x[i - 1] + stepX);
    }
    x.push(secondX);

    y.unshift(firstY);
    for (let i = 1; i < chartAccuracy - 1; i++) {
        y.push((x[i] - x[0]) * slope + y[0]);
    }
    y.push(secondY);

    return x.map((xValue, index) => ({
        x: Math.round(xValue),
        y: Math.round(y[index]),
    }));
};

export const calculateProfitChartByPrice = (coordinates, chartAccuracy) => {
    return coordinates.reduce((acc, segment) => {
        const processedSegment = initialCoordinates(segment, chartAccuracy);
        return acc.concat(processedSegment);
    }, []);
};

export const calculateProfitChartByPercent = (chartData, profitFactor) => {
    return chartData.map((dataPoint) => ({
        x: dataPoint.x,
        y: (dataPoint.y / Math.abs(profitFactor)) * 100,
    }));
};